<template>
	<CModal title="Ajouter un produit" size="lg" :show.sync="showModal" :key="formId">
		<form ref="mainForm" action="/api/products" method="post" axiosMethod="post">
			<FormModal />
		</form>

		<template #footer>
			<CButton color="secondary" v-on:click="showModal = false">Annuler</CButton>
			<CButton color="success" v-on:click="onSubmit($refs.mainForm)">Ajouter</CButton>
		</template>
	</CModal>
</template>

<script>
	import FormModal from './form-modal';
	import { uniqueId } from 'lodash';

	export default {
		name: 'add-modal',
		components: { FormModal },

		data() {
			return {
				formId: uniqueId('id'),
				showModal: false,
			};
		},

		methods: {
			onSubmit: function (form) {
				this.$formDataToApi.sendForm(form).then(res => {
					if (res.status === 200 || res.status === 201) {
						this.showModal = false;
						this.$toast.success('Ajouté avec succès !');
						this.formId = uniqueId('id');
						this.$emit('refresh');
					}
				});
			},
		},
	};
</script>
